export const normalizeAddress = (order) => {
  if (!order) return { full: "Montreal, QC", forGPS: "Montreal, QC" };

  const street = [order.streetNumber, order.streetName?.trim()].filter(Boolean).join(' ');
  
  // City mapping
  const cityMap = { 'csl': 'Côte-Saint-Luc', 'vsl': 'Saint-Laurent', 'ddo': 'Dollard-des-Ormeaux' /* ... rest of your map */ };
  const city = cityMap[order.city?.toLowerCase().trim()] || order.city || 'Montreal';

  // Postal code formatting
  let postal = (order.postalCode || '').toUpperCase().replace(/\s+/g, '');
  if (postal.length === 6) postal = postal.slice(0, 3) + ' ' + postal.slice(3);

  // CRITICAL: Construct two versions
  // 1. The "Full" version for the UI/Driver
  const full = `${street}${order.unit ? ' Apt ' + order.unit : ''}, ${city}, ${postal}, QC, Canada`;
  
  // 2. The "GPS" version (NO UNIT/APT)
  const forGPS = `${street}, ${city}, ${postal}, Canada`;

  return { full, forGPS };
};